var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["user-review-star-rating.j2"] = require( "user-review-star-rating.j2" );
dependencies["user-review-photos.j2"] = require( "user-review-photos.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/user-review-title-section.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-product-review__star-rating\">\n    ";
env.getTemplate("user-review-star-rating.j2", false, "product/templates/user-review-title-section.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n</div>\n\n<p class=\"c-product-review__timestamp\">\n    ";
output += runtime.suppressValue(env.getFilter("format_iso_datetime").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "review")),"LastModificationTime")), env.opts.autoescape);
output += "\n</p>\n\n<div class=\"u-extra-small--show u-medium--hide\">\n\t";
env.getTemplate("user-review-photos.j2", false, "product/templates/user-review-title-section.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n</div>\n\n<h3 class=\"c-product-review__h3\">\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "review")),"Title")), env.opts.autoescape);
output += "\n</h3>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/user-review-title-section.j2"] , dependencies)